<ng-select
  [multiple]="to.multiple"
  bindValue="value"
  [formControl]="formControl"
  [placeholder]="to.placeholder"
  [items]="opts | async"
  [clearable]="clearable">
</ng-select>
